import { Box, Skeleton, Stack, styled, Typography } from '@mui/material';

import { useConferences } from '../hooks';

import { Card } from './Card';
import { HomeLayout } from './HomeLayout';

export const Calendar = () => {
  const { data, isFetching, error } = useConferences();

  return (
    <HomeLayout title="ChangeGPS calendar">
      <Card
        bottomLink={{
          link: 'https://vimeo.com/showcase/2394590',
          text: 'View previous web events',
        }}
      >
        <Typography sx={{ fontWeight: 500, fontSize: 18 }}>
          Upcoming events
        </Typography>
        {error || isFetching ? (
          <LoadingSkeleton />
        ) : (
          <StyledBox>
            {/* <Box sx={{ height: 20 }} /> */}
            {data?.conferences.map((item) => (
              <Box key={item.id} sx={{ mb: 1 }}>
                <Box
                  sx={{
                    backgroundColor: item.color,
                    borderRadius: 2,
                    p: '14px 20px',
                  }}
                >
                  <Stack direction="row">
                    <Stack alignItems="center" justifyContent="center">
                      <Typography
                        sx={{
                          color: 'white',
                          fontWeight: 700,
                          fontSize: 30,
                          lineHeight: '100%',
                        }}
                      >
                        {item.date}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'white',
                          fontWeight: 700,
                          fontSize: 16,
                          lineHeight: '100%',
                        }}
                      >
                        {item.month}
                      </Typography>
                    </Stack>

                    <Box sx={{ width: 20 }} />

                    <Stack justifyContent="center">
                      {item.tag && (
                        <Box
                          sx={{
                            backgroundColor: '#F6ECF1',
                            borderRadius: 30,
                            width: 'fit-content',
                            px: 1,
                            mb: 0.75,
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#202227',
                              fontWeight: 400,
                              fontSize: 11,
                              textAlign: 'center',
                            }}
                          >
                            {item.tag}
                          </Typography>
                        </Box>
                      )}

                      <Typography
                        sx={{
                          color: 'white',
                          fontWeight: 700,
                          fontSize: 15,
                          mb: 0.5,
                        }}
                      >
                        {item.title}
                      </Typography>

                      <Typography
                        sx={{ color: 'white', fontWeight: 400, fontSize: 13 }}
                      >
                        {item.day}, {item.time}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Box>
            ))}
          </StyledBox>
        )}
      </Card>
    </HomeLayout>
  );
};

const LoadingSkeleton = () => {
  return (
    <StyledBox>
      <Stack spacing={1}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} variant="rounded" width={'100%'} height={64} />
        ))}
      </Stack>
    </StyledBox>
  );
};

const StyledBox = styled(Box)({ marginTop: 20 });
